import React, { useEffect, useState } from 'react';
import { Modal, Button, Input, Select } from 'antd';
import { PlayCircleOutlined, CheckCircleOutlined } from '@ant-design/icons';
import { languageOptions } from '../../utils';

const VideoBucketModal = ({ 
  open, 
  onCancel, 
  videos = [], 
  onSelect, 
  selectedVideoUrl = null,
  setSelectedVideo,
  selectedVideo,
  organizations = [], // Add these props
  interpreters = [],
  onFiltersChange // Add callback for filter changes
}) => {
  const [filters, setFilters] = useState({
    search: '',
    organization: undefined,
    interpreter: undefined,
    language: undefined
  });
  const [previewUrl, setPreviewUrl] = useState(null);

  // Handle filter changes
  useEffect(() => {
    if (onFiltersChange) {
      onFiltersChange(filters);
    }
  }, [filters, onFiltersChange]);

  
  const handleVideoSelect = (video) => {
    if (selectedVideo?._id === video._id) {
      setSelectedVideo(null);
      onSelect(null);
    } else {
      setSelectedVideo(video);
      onSelect(video.url);
    }
  };
  const handleVideoHover = (videoUrl) => {
    setPreviewUrl(videoUrl);
  };
  return (
    <Modal
      title="Select Video from Bucket"
      open={open}
      onCancel={onCancel}
      width={1300}
      footer={null}
    >
      <div className="flex  gap-4 mb-4">
        <Input
          placeholder="Search videos..."
          allowClear
          className="min-w-[100px] rounded-xl h-11"
          onChange={(e) => setFilters(prev => ({ 
            ...prev, 
            search: e.target.value.trim() 
          }))}
        />
        <Select
          allowClear
          placeholder="Language"
          className="min-w-[200px] rounded-xl h-11"
          onChange={(value) => setFilters(prev => ({ 
            ...prev, 
            language: value 
          }))}
        >
          {languageOptions.map(option => (
            <Option key={option.value} value={option.value}>
              {option.label}
            </Option>
          ))}
        </Select>
        <Select
          allowClear
          placeholder="Organisation"
          className="min-w-[200px] rounded-xl h-11"
          onChange={(value) => setFilters(prev => ({ 
            ...prev, 
            organization: value 
          }))}
        >
          {organizations?.map(org => (
            <Option key={org._id} value={org._id}>{org.name}</Option>
          ))}
        </Select>
        <Select
          allowClear
          placeholder="Presenter"
          className="min-w-[200px] rounded-xl h-11"
          onChange={(value) => setFilters(prev => ({ 
            ...prev, 
            interpreter: value 
          }))}
        >
          {interpreters?.map(interpreter => (
            <Option key={interpreter._id} value={interpreter._id}>
              {interpreter?.user?.full_name || 'Unnamed Interpreter'}
            </Option>
          ))}
        </Select>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 max-h-[60vh] overflow-y-auto p-4">
      {videos.length > 0 ? (
    videos.map((video) => (
          <div
            key={video._id}
            className={`relative rounded-xl border cursor-pointer transition-all ${
              selectedVideo?._id === video._id 
                ? 'border-blue-500 shadow-lg' 
                : 'border-gray-200 hover:border-blue-300'
            }`}
            onClick={() => handleVideoSelect(video)}
            onMouseEnter={() => handleVideoHover(video.url)}
            onMouseLeave={() => setPreviewUrl(null)}
          >
            <div className="aspect-video relative rounded-t-xl overflow-hidden bg-gray-100">
              <video
                src={previewUrl === video.url ? video.url :video.url}
                className="w-full h-full object-cover"
                // poster="/api/placeholder/400/225"
                controls 

                autoPlay={previewUrl === video.url}
                loop
              />
              {/* <div className="absolute inset-0 bg-black bg-opacity-30 flex items-center justify-center">
                {selectedVideo?._id === video._id ? (
                  <CheckCircleOutlined className="text-4xl text-blue-500" />
                ) : (
                  <PlayCircleOutlined className="text-4xl text-white opacity-90" />
                )}
              </div> */}
            </div>
            <div className="p-3">
              <h4 className="font-medium text-lg mb-1 line-clamp-1 mt-0">{video.title}</h4>
              <p className="text-gray-500 text-sm line-clamp-2">{video.description}</p>
              <p className="text-gray-500 text-sm line-clamp-2">Language: {video.language}</p>

              
              {video.organization?.name && (
                <div className="mt-2">
                  <span className="text-xs bg-gray-100 px-2 py-1 rounded-full">
                    {video.organization.name}
                  </span>
                </div>
              )}
            </div>
          </div>
        
      ))
    ) : (
      <div className="col-span-full flex flex-col items-center justify-center py-12 px-4">
        <div className="text-gray-400 mb-3">
          <PlayCircleOutlined style={{ fontSize: '48px' }} />
        </div>
        <h3 className="text-lg font-medium text-gray-900 mb-1">No videos found</h3>
        <p className="text-gray-500 text-center">Try adjusting your filters or search terms to find videos.</p>
      </div>
    )}
  
      </div>
    </Modal>
  );
};

export default VideoBucketModal;